module.exports = __webpack_public_path__ + "static/media/data3.d0a25769.webp";